export default {
    computed: {
        projectLocation () {
            return {
                street: this.project.projektort_strasse || this.project.projekttraeger_strasse,
                number: this.project.projektort_nummer || this.project.projekttraeger_nummer,
                zipcode: this.project.projektort_plz || this.project.projekttraeger_plz,
                city: this.project.projektort_ort || this.project.projekttraeger_ort,
                geoposition: {
                    available: this.project.lng && this.project.lat,
                    lng: this.project.lng || null,
                    lat: this.project.lat || null
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/ProjectLocation.js